module.exports = __webpack_public_path__ + "img/jeweller.4ad99b6.jpg";